import { getContextInsights } from "../api/contextInsights.api";

function pickTypeByScore(score01) {
	if (score01 === undefined || score01 === null) return "info";
	if (score01 >= 0.85) return "success";
	if (score01 >= 0.7) return "info";
	if (score01 >= 0.5) return "warning";
	return "danger";
}

export async function fetchContextInsights(params) {
	const raw = await getContextInsights(params);

	// Preferred shape: { contextualInsights: [{ type, text }] }
	const provided = raw?.data?.contextualInsights || raw?.contextualInsights;
	let insights;
	if (Array.isArray(provided)) {
		insights = provided.map(i => ({
			type: i.type || "info",
			text: i.text || ""
		}));
	} else {
		// Backward-compat: { contexts: [...] } with derived text/type
		const contexts = raw?.data?.contexts || [];
		insights = contexts.map((c) => {
			const name = c.context || c.category || "Context";
			const count = c.count ?? c.usage ?? 0;
			const score01 = c.avg_score ?? c.confidence ?? null;
			const scorePct = score01 !== null ? `${Math.round(Number(score01) * 100)}%` : null;
			const text = scorePct
				? `${name} • ${count.toLocaleString()} uses • avg confidence ${scorePct}`
				: `${name} • ${count.toLocaleString()} uses`;
			return { type: pickTypeByScore(score01), text };
		});
	}
	return { insights, raw };
}


